/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * FieldSource
 * Кто положил значение в поле.
 */
export type FieldSource = "unset" | "llm" | "crm" | "local_profile" | "manual";

/** CardResponse */
export interface CardResponse {
  card: VisitCardDTO;
}

/** ClientDTO */
export interface ClientDTO {
  /** Client Code */
  client_code?: string | null;
  /**
   * Is New
   * @default true
   */
  is_new?: boolean;
  /** Last Name */
  last_name?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Patronymic */
  patronymic?: string | null;
  /** Phone */
  phone?: string | null;
  phone_type?: FieldValueDTO;
  /** Email */
  email?: string | null;
  client_type?: FieldValueDTO;
  juridical_type?: FieldValueDTO;
  social_status?: FieldValueDTO;
}

/** FieldValueDTO */
export interface FieldValueDTO {
  /** Id */
  id?: number | string | null;
  /** Name */
  name?: string | null;
  /** Raw */
  raw?: string | null;
  /**
   * Confidence
   * @default 0
   */
  confidence?: number;
  /**
   * Кто положил значение в поле.
   * @default "unset"
   */
  source?: FieldSource;
  /**
   * Manual
   * @default false
   */
  manual?: boolean;
}

/** FunnelDTO */
export interface FunnelDTO {
  room?: FieldValueDTO;
  furniture_volume?: FieldValueDTO;
  design_project?: FieldValueDTO;
  plan_start?: FieldValueDTO;
  functional_zone?: FieldValueDTO;
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[];
}

/** InitCardRequest */
export interface InitCardRequest {
  /**
   * Phone
   * Телефон для CRM pre-fill (опционально)
   */
  phone?: string | null;
  /**
   * Profile Name
   * Имя локального профиля (selectedProfileId). Если phone не передан, бэкенд попробует разрешить его через данный профиль.
   */
  profile_name?: string | null;
}

/** PatchClientBlock */
export interface PatchClientBlock {
  /** Last Name */
  last_name?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Patronymic */
  patronymic?: string | null;
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  /** Client Code */
  client_code?: string | null;
}

/** PatchDropdownItem */
export interface PatchDropdownItem {
  /** Id */
  id?: number | string | null;
  /** Name */
  name?: string | null;
}

/** PatchRequest */
export interface PatchRequest {
  client?: PatchClientBlock | null;
  /** Dropdowns */
  dropdowns?: Record<string, PatchDropdownItem | null> | null;
  /** Comments */
  comments?: string | null;
}

/** PatchResponse */
export interface PatchResponse {
  card: VisitCardDTO;
  /** Diff */
  diff?: object;
}

/** SubmissionDTO */
export interface SubmissionDTO {
  /** Idclient */
  idclient?: string | null;
  /** Itphone */
  itphone?: number | null;
  /** Itcallreg */
  itcallreg?: number | null;
  /** Itcall */
  itcall?: number | null;
  /**
   * Primary Needs Done
   * @default false
   */
  primary_needs_done?: boolean;
  /**
   * Completed
   * @default false
   */
  completed?: boolean;
  /** Submitted By */
  submitted_by?: string | null;
  /** Submitted At */
  submitted_at?: string | null;
  /** Commit Mode */
  commit_mode?: string | null;
}

/** SubmitNamedId */
export interface SubmitNamedId {
  /** Id */
  id?: number | string | null;
  /** Name */
  name?: string | null;
}

/** SubmitClientDump */
export interface SubmitClientDump {
  /** Last Name */
  last_name?: string | null;
  /** First Name */
  first_name?: string | null;
  /** Patronymic */
  patronymic?: string | null;
  /** Phone */
  phone?: string | null;
  /** Email */
  email?: string | null;
  juridical_type?: SubmitNamedId | null;
  social_status?: SubmitNamedId | null;
}

/** SubmitMainDump */
export interface SubmitMainDump {
  /** Designer */
  designer?: string | null;
  /** Salon */
  salon?: string | null;
  /** Dealer */
  dealer?: string | null;
  /** Ad Source */
  ad_source?: string | null;
  /** Brand */
  brand?: string | null;
  /** Product Group */
  product_group?: string | null;
  /** Refusal Reason */
  refusal_reason?: string | null;
  /** Comments */
  comments?: string | null;
}

/** SubmitRequest */
export interface SubmitRequest {
  /**
   * Commit
   * 'T' — закоммитить, 'F' — dry-run
   * @default "T"
   */
  commit?: string;
  /**
   * Profile Name
   * Имя локального профиля (selectedProfileId) — ключ папки на диске.
   */
  profile_name?: string | null;
  client?: SubmitClientDump | null;
  main?: SubmitMainDump | null;
}

/** SubmitResponse */
export interface SubmitResponse {
  card: VisitCardDTO;
  submission: SubmissionDTO;
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[];
  /** Message */
  msg: string;
  /** Error Type */
  type: string;
}

/** VisitCardDTO */
export interface VisitCardDTO {
  /** Session Id */
  session_id: string;
  client: ClientDTO;
  visit_type: FieldValueDTO;
  ad_source_group: FieldValueDTO;
  ad_source: FieldValueDTO;
  dealer: FieldValueDTO;
  brand: FieldValueDTO;
  product_group: FieldValueDTO;
  designer: FieldValueDTO;
  status: FieldValueDTO;
  refusal_reason: FieldValueDTO;
  city_group: FieldValueDTO;
  /**
   * Comments
   * @default ""
   */
  comments?: string;
  funnel: FunnelDTO;
  /**
   * Profile Dossier
   * @default ""
   */
  profile_dossier?: string;
  submission: SubmissionDTO;
  /**
   * Last Extracted Words
   * @default 0
   */
  last_extracted_words?: number;
  /** Last Extracted At */
  last_extracted_at?: string | null;
  /** Created At */
  created_at: string;
  /** Updated At */
  updated_at: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Mr Doors — Visit Card Service
 * @version 0.1.0
 */
export class VisitCardAPI<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  health = {
    /**
     * No description
     *
     * @tags Health
     * @name HealthHealthGet
     * @summary Health
     * @request GET:/health
     */
    healthHealthGet: (params: RequestParams = {}) =>
      this.request<Record<string, string>, any>({
        path: `/health`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  copilot = {
    /**
     * No description
     *
     * @tags Visit Card
     * @name InitCardCopilotSessionSessionIdVisitCardInitPost
     * @summary Init Card
     * @request POST:/copilot/session/{session_id}/visit-card/init
     */
    initCardCopilotSessionSessionIdVisitCardInitPost: (
      sessionId: string,
      data: InitCardRequest,
      params: RequestParams = {},
    ) =>
      this.request<CardResponse, HTTPValidationError>({
        path: `/copilot/session/${sessionId}/visit-card/init`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visit Card
     * @name GetCardCopilotSessionSessionIdVisitCardGet
     * @summary Get Card
     * @request GET:/copilot/session/{session_id}/visit-card
     */
    getCardCopilotSessionSessionIdVisitCardGet: (
      sessionId: string,
      params: RequestParams = {},
    ) =>
      this.request<CardResponse, HTTPValidationError>({
        path: `/copilot/session/${sessionId}/visit-card`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visit Card
     * @name PatchCardCopilotSessionSessionIdVisitCardPatch
     * @summary Patch Card
     * @request PATCH:/copilot/session/{session_id}/visit-card
     */
    patchCardCopilotSessionSessionIdVisitCardPatch: (
      sessionId: string,
      data: PatchRequest,
      params: RequestParams = {},
    ) =>
      this.request<PatchResponse, HTTPValidationError>({
        path: `/copilot/session/${sessionId}/visit-card`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Visit Card
     * @name SubmitCardCopilotSessionSessionIdVisitCardSubmitPost
     * @summary Submit Card
     * @request POST:/copilot/session/{session_id}/visit-card/submit
     */
    submitCardCopilotSessionSessionIdVisitCardSubmitPost: (
      sessionId: string,
      data: SubmitRequest,
      params: RequestParams = {},
    ) =>
      this.request<SubmitResponse, HTTPValidationError>({
        path: `/copilot/session/${sessionId}/visit-card/submit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  visitCard = {
    /**
     * No description
     *
     * @tags References
     * @name ReferencesAllVisitCardReferencesGet
     * @summary References All
     * @request GET:/visit-card/references
     */
    referencesAllVisitCardReferencesGet: (params: RequestParams = {}) =>
      this.request<Record<string, object[]>, any>({
        path: `/visit-card/references`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags References
     * @name ReferencesByKeyVisitCardReferencesKeyGet
     * @summary References By Key
     * @request GET:/visit-card/references/{key}
     */
    referencesByKeyVisitCardReferencesKeyGet: (
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<object[], HTTPValidationError>({
        path: `/visit-card/references/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
